import { quiz, getQuizResults } from './quiz';
import { createCookie } from './cookies';


// EMAIL LOCKED CONTENT
const emailUnlock = document.querySelector('[data-email-unlock]');
function unlockContent(emailUnlock){
    // unlock element
    const unlockElement = document.getElementById(emailUnlock.dataset.emailUnlock)
    if( unlockElement ){
        unlockElement.classList.remove('email-locked');
        unlockElement.classList.add('fade-in-fast');
        emailUnlock.classList.add('unlocked');
    }
    // move to top
    window.scrollTo(0, 0);
}


// KLAVIYO EVENT LISTENER
window.addEventListener("klaviyoForms", function(e) { 
    console.log('klaviyoForms EVENT: '+JSON.stringify(e.detail));
    // console.log('Klaviyo Event type: '+e.detail.type);
    
    if (e.detail.type == 'embedOpen') {
        // console.log('Klaviyo Event: open');
    }
    if (e.detail.type == 'close') {
        // console.log('Klaviyo Event: close');
    }
    if (e.detail.type == 'submit') {
        console.log('Klaviyo Event: submit:'+e.detail.metaData.$email);

        // create subscribed cookie
        createCookie('subscribedToKlaviyo', JSON.stringify(e.detail.metaData), 365);

        if(quiz){
            console.log(`Quiz submit`);
            quiz.dataset.state = 'submitted';
            setTimeout(()=>{
                getQuizResults(e.detail.metaData);
            },2500);            
        }
        if(emailUnlock){
            console.log(`Unlock submit`);
            setTimeout(()=>{
                unlockContent(emailUnlock);
            },2500);
        }
        if(quiz || emailUnlock){

        }
    }
});